import { render, staticRenderFns } from "./YoyoCoinIntroduce.vue?vue&type=template&id=6d8b0bbb&scoped=true"
import script from "./YoyoCoinIntroduce.vue?vue&type=script&lang=js"
export * from "./YoyoCoinIntroduce.vue?vue&type=script&lang=js"
import style0 from "./YoyoCoinIntroduce.vue?vue&type=style&index=0&id=6d8b0bbb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b0bbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8b0bbb')) {
      api.createRecord('6d8b0bbb', component.options)
    } else {
      api.reload('6d8b0bbb', component.options)
    }
    module.hot.accept("./YoyoCoinIntroduce.vue?vue&type=template&id=6d8b0bbb&scoped=true", function () {
      api.rerender('6d8b0bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main-tabs/YoyoCoinIntroduce.vue"
export default component.exports